import { OutlineButton } from "Components/HomeV2/Buttons";
import ContainedButton from "Components/HomeV2/Buttons/Contained";
import image from "../../Assets/AIOnDemand/ai-advisor.png";
import bgImage from "../../Assets/homev2/el-bg.png";
const StartYourGrowth = () => {
    return (
        <section
            className="w-full bg-cover bg-no-repeat bg-bottom overflow-hidden  relative"
            style={{
                backgroundImage: `url(${bgImage})`,
            }}
        >
            <div className="w-full h-full max-w-[1500px] mx-auto px-4 pt-8 md:pt-20 flex flex-col justify-between gap-4 lg:gap-8 items-center">
                <div>
                    <h2 className="text-3xl flex flex-row items-center justify-center gap-4 md:text-5xl lg:text-7xl text-black font-semibold text-center">
                        Start Your AI Growth Engine
                    </h2>
                    <h4 className="text-center text-black md:text-2xl mt-4">
                        Book a free strategy call to see where your org can automate in just 30 days.
                    </h4>
                    <div className="flex  max-w-[180px] items-center flex-col md:flex-row gap-4 md:gap-6 md:max-w-max md:w-max mx-auto  mb-14 md:mb-0 mt-4 md:mt-10">
                        <a
                            href="https://calendly.com/salesbox-meet/ai-ondemand"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="w-full"
                        >
                            <ContainedButton theme="primary">
                                <span className="flex items-center gap-2">
                                    <span className="w-2 h-2 bg-white block rounded-full" />
                                    Live Call
                                </span>
                            </ContainedButton>
                        </a>
                        <a
                            href="https://calendly.com/salesbox-meet/ai-ondemand"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="w-full"
                        >
                            <OutlineButton theme="black">Schedule Call</OutlineButton>
                        </a>
                    </div>
                </div>
                <div className=" relative max-w-[1400px] px-10 mt-10">
                    <img
                        src={image}
                        alt="Customize my solution"
                        width="100%"
                        height="100%"
                        loading="lazy"
                        className="object-contain"
                    />
                </div>
            </div>

        </section>
    );
}

export default StartYourGrowth;